<template>
    <div class="row">
        <div class="col-md-6 d-flex justify-content-center flex-column">
            <div class="count">
                {{ pos }}
            </div>
            <b-tooltip v-if="!add.positive" :target="'like-button-' + dbid" placement="top">
                Dodałeś już opinię pozytywną, możesz ją zmienić na negatywną.
            </b-tooltip>
            <b-tooltip v-if="sameUser" :target="'like-button-' + dbid" placement="top">
                Nie możesz dodać sobie opinii!
            </b-tooltip>
            <div :id="'like-button-' + dbid" class="like-button" @click="handleClick(true)" :class="[!add.positive || sameUser ? 'dis' : '']">
                <i class="fa fa-thumbs-up"/>
            </div>
        </div>
        <div class="col-md-6 d-flex justify-content-center flex-column">
            <div class="count">
                {{ neg }}
            </div>
            <b-tooltip v-if="!add.negative" :target="'dislike-button-' + dbid" placement="top">
                Dodałeś już opinię negatywną, możesz ją zmienić na pozytywną.
            </b-tooltip>
            <b-tooltip v-if="sameUser" :target="'dislike-button-' + dbid" placement="top">
                Nie możesz dodać sobie opinii!
            </b-tooltip>
            <div :id="'dislike-button-' + dbid" class="dislike-button" @click="handleClick(false)" :class="[!add.negative || sameUser ? 'dis' : '']">
                <i class="fa fa-thumbs-down"/>
            </div>
        </div>
    
        <b-modal
            :id="'modal-add-' + dbid"
            centered
            title="Dodaj opinię"
            title-class="font-18"
        >
            <div>
                <form @submit.prevent="" class="row">
                    <div class="col">
                        <div class="position-relative">
                             <textarea
                                 type="text"
                                 v-model="opinion"
                                 class="form-control"
                                 placeholder="Wpisz treść..."
                                 :class="{'is-invalid': $v.opinion.$error}"
                             ></textarea>
                            <div v-if="$v.opinion.$error" class="invalid-feedback">
                                <span v-if="!$v.opinion.required">Opinia jest wymagana.</span>
                                <span v-if="!$v.opinion.minLength">Wprowadź co najmniej 5 znaków.</span>
                                <span v-if="!$v.opinion.maxLength">Wprowadź maksymalnie 1000znaków.</span>
                                <span v-if="!$v.opinion.badPhrases">Niedopuszczalna fraza w tekście.</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <span>
                        Typ opinii:
                        <span v-if="positive" class="text-success">Pozytywna</span>
                        <span v-else class="text-danger">Negatywna</span>
                    </span>
                    <b-button
                        variant="primary"
                        size="sm"
                        class="float-right"
                        @click="handleAdd"
                    >
                        <i class="fa fa-plus"></i> Dodaj opinię
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {maxLength, minLength, required} from "vuelidate/lib/validators";
import AdminOpinionsService from "@/services/admin-opinions.service";
import {notificationMethods} from "@/state/helpers";
import badPhrases from "@/validators/badPhrases.validator";

export default {
    name: "AdminOpinion",
    props: {
        dbid: String,
        pos: Number,
        neg: Number,
        add: Object
    },
    data() {
        return {
            opinion: "",
            positive: null,
            sameUser: false
        }
    },
    validations: {
        opinion: {badPhrases: badPhrases, required: required, minLength: minLength(5), maxLength: maxLength(1000)},
    },
    computed: {
        user() {
            return this.$store.getters['auth/user'];
        }
    },
    mounted() {
        if (this.user.clientDbid == this.dbid)
            this.sameUser = true;
    },
    methods: {
        ...notificationMethods,
        handleClick(positive) {
            if ((positive && !this.add.positive) ||
                (!positive && !this.add.negative) ||
                this.sameUser)
                return;
            
            this.positive = positive;
            this.$bvModal.show("modal-add-" + this.dbid);
        },
        handleAdd() {
            this.$v.opinion.$touch();
        
            if (this.$v.opinion.$invalid) {
                return;
            } else {
                this.$bvModal.hide("modal-add-" + this.dbid);
            
                AdminOpinionsService.save(this.dbid, this.opinion, this.positive).then(
                    () => {
                        this.success("Opinia została dodana!");
                        this.opinion = "";
                        this.positive = null;
                        this.$v.opinion.$reset();
                        this.$emit('added');
                    },
                    error => {
                        console.log(error);
                    }
                )
            }
        },
    }
}
</script>

<style scoped lang="scss">
.like-button,
.dislike-button {
    margin: auto;
    width: 90px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    transition: all .2s ease-in-out;
}

.like-button.dis,
.dislike-button.dis {
    cursor: not-allowed;
    opacity: 0.5;
}

.like-button:not(.dis),
.dislike-button:not(.dis) {
    &:hover {
        font-size: 1.2rem;
    }
}

.like-button {
    background-color: var(--success);
}

.dislike-button {
    background-color: var(--danger);
}

.count {
    text-align: center;
    font-weight: bold;
    font-size: 1.3rem;
}
</style>